import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Spray = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.43 82.95">
  <G fill={color}>
    <Path d="M22.4,28.14h-11.08c-6.24,0-11.32,5.08-11.32,11.32v40.49c0,1.66,1.34,3,3,3h27.72c1.66,0,3-1.34,3-3v-40.49c0-6.24-5.08-11.32-11.32-11.32ZM22.33,67.32h-10.74c-1.66,0-3-1.34-3-3s1.34-3,3-3h10.74c1.66,0,3,1.34,3,3s-1.34,3-3,3ZM22.33,51.51h-10.74c-1.66,0-3-1.34-3-3s1.34-3,3-3h10.74c1.66,0,3,1.34,3,3s-1.34,3-3,3Z"/>
    <Path d="M7.3,26.72h19.32c1.66,0,3-1.34,3-3s-1.34-3-3-3h-1.29v-8.71c0-1.66-1.34-3-3-3h-10.74c-1.66,0-3,1.34-3,3v8.71h-1.29c-1.66,0-3,1.34-3,3s1.34,3,3,3Z"/>
    <Path d="M39.11,12.94h-3.51c-1.66,0-3,1.34-3,3s1.34,3,3,3h3.51c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"/>
    <Path d="M50.43,12.94h-3.51c-1.66,0-3,1.34-3,3s1.34,3,3,3h3.51c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"/>
    <Path d="M34.1,11.48c.37,0,.74-.07,1.11-.21l3.26-1.3c1.54-.61,2.29-2.36,1.68-3.9-.61-1.54-2.36-2.29-3.9-1.68l-3.26,1.3c-1.54.61-2.29,2.36-1.68,3.9.47,1.18,1.6,1.89,2.79,1.89Z"/>
    <Path d="M44.63,7.3c.37,0,.74-.07,1.11-.21l3.27-1.3c1.54-.61,2.29-2.36,1.68-3.9-.61-1.54-2.36-2.29-3.9-1.68l-3.26,1.3c-1.54.61-2.29,2.36-1.68,3.9.47,1.18,1.6,1.89,2.79,1.89Z"/>
    <Path d="M38.48,21.92l-3.26-1.3c-1.54-.61-3.29.14-3.9,1.68-.61,1.54.14,3.29,1.68,3.9l3.26,1.3c.36.14.74.21,1.11.21,1.19,0,2.32-.72,2.79-1.89.61-1.54-.14-3.29-1.68-3.9Z"/>
    <Path d="M49,26.1l-3.27-1.3c-1.54-.61-3.29.14-3.9,1.68-.61,1.54.14,3.29,1.68,3.9l3.26,1.3c.36.14.74.21,1.11.21,1.19,0,2.32-.72,2.79-1.89.61-1.54-.14-3.29-1.68-3.9Z"/>
  </G>
</Svg>
);
};

export default Spray;
